/**
 * El encabezado y la barra de navegación que salen en TODAS las pantallas.
 *
 * `Cerrar sesión` for logout, matching `Iniciar sesión` on the sign-in page — the pair reads as a pair.
 * `Panel` for dashboard, which is what Spanish-language software prints; `Tablero` is a board you pin
 * things to and is already taken by the Office Board module.
 *
 * `Reporte diario`, not `Informe diario`. Both are correct Spanish; `reporte` is the one used in
 * Mexico and Central America, which is who reads this. The word is chosen ONCE, here, and every other
 * screen in this branch takes it from a dictionary rather than re-deciding.
 */
export default {
  companyLogo: 'Logo de la empresa',
  back: 'Atrás',
  goBack: 'Regresar',
  portal: 'Portal',
  profile: 'Perfil',
  admin: 'Administración',
  logout: 'Cerrar sesión',
  dashboard: 'Panel',
  appVersion: 'Versión de la aplicación',
  employee: 'Empleado',

  // ── el timbre de notificaciones ───────────────────────────────────────────────────────────────
  notifications: 'Notificaciones',
  markAllRead: 'Marcar todo como leído',
  noNotifications: 'Sin notificaciones',
  noOtherNotifications: 'No hay otras notificaciones',
  actionRequired: (n) => (n === 1
    ? 'Falta atender — 1 reporte esperando aprobación'
    : `Falta atender — ${n} reportes esperando aprobación`),
  dailyReport: 'Reporte diario',
  statusLabel: 'Estado',
  reviewedNeedsApproval: 'Revisado — falta aprobar',
  submittedNeedsReview: 'Enviado — falta revisar',
  review: 'Revisar',
}
